import React from "react";
import ReactDOM from "react-dom";
import { Route, BrowserRouter as Router } from "react-router-dom";

import config from "./utils/const";

//style
import "./styles/style.scss";

//components
import { ProviderDefault, ConsumerDefault } from "./context/Provider";
import ButtomClose from "./components/ButtomClose";

//Routes
import Start from "./views/Start";
import Esporte from "./views/Esporte";
import EsportePerfil from "./views/Esporte/Perfil";
import EsporteFisica from "./views/Esporte/Fisica";
import EsporteJuridica from "./views/Esporte/Juridica";
import Educacao from "./views/Educacao";
import Type from "./views/Educacao/Type";
import EducacaoPerfil from "./views/Educacao/Profile";
import Amount from "./views/Educacao/Amount";
import EducacaoFisica from "./views/Educacao/Fisica";
import EducacaoJuridica from "./views/Educacao/Juridica";
import Payment from "./views/Educacao/Payment";
import Thankyou from "./views/Educacao/Thankyou";

const routing = (
  <>
    <ButtomClose />
    <ProviderDefault>
      <Router>
        <Route exact path={`${config.url}`} component={Start} />
        <Route exact path={`${config.url}esporte`} component={Esporte} />
        <Route exact path={`${config.url}esporte/perfil`} component={EsportePerfil} />
        <Route exact path={`${config.url}esporte/pessoa-fisica`} component={EsporteFisica} />
        <Route exact path={`${config.url}esporte/pessoa-juridica`} component={EsporteJuridica} />
        <Route exact path={`${config.url}educacao`} component={Educacao} />
        <Route exact path={`${config.url}educacao/perfil`} component={() => <ConsumerDefault>{props => <EducacaoPerfil {...props} />}</ConsumerDefault>} />
        <Route exact path={`${config.url}educacao/tipo-doacao`} component={() => <ConsumerDefault>{props => <Type {...props} />}</ConsumerDefault>} />
        <Route path={`${config.url}educacao/amount/:monthly/`} component={argsNav => <ConsumerDefault>{props => <Amount {...props} {...argsNav} />}</ConsumerDefault>} />
        <Route exact path={`${config.url}educacao/pf`} component={() => <ConsumerDefault>{props => <EducacaoFisica {...props} />}</ConsumerDefault>} />
        <Route exact path={`${config.url}educacao/pj`} component={() => <ConsumerDefault>{props => <EducacaoJuridica {...props} />}</ConsumerDefault>} />
        <Route exact path={`${config.url}educacao/payment`} component={() => <ConsumerDefault>{props => <Payment {...props} />}</ConsumerDefault>} />
        <Route exact path={`${config.url}educacao/thankyou`} component={() => <ConsumerDefault>{props => <Thankyou {...props} />}</ConsumerDefault>} />
      </Router>
    </ProviderDefault>
  </>
);

ReactDOM.render(routing, document.getElementById("donation"));
